import request from "@/api/request";

export default {
    // 统计
    result: async data => request({ url: '/console/basic.Index/index', data }),

    // 通知
    getList: async data => request({ url: '/console/basic.Notify/getList', data }),
}
